$(document).ready(function() {
  $('#productModal').on('show.bs.modal', function (event) {
    var button = $(event.relatedTarget)
    var product = button.data('product')
    var modal = $(this)

    Shopify.getProduct(product, function(product){	
      // Grab the template script
      $(function() { 
        var theTemplateScript = $("#add-modal-template").text()
        
        Handlebars.setDelimiter = function(start,end){
          //save a reference to the original compile function
          if(!Handlebars.original_compile) Handlebars.original_compile = Handlebars.compile;

          Handlebars.compile = function(source){
            var s = "\\"+start,
              e = "\\"+end,
              RE = new RegExp('('+s+')(.*?)('+e+')','ig');

              replacedSource = source.replace(RE,function(match, startTags, text, endTags, offset, string){
                var startRE = new RegExp(s,'ig'), endRE = new RegExp(e,'ig');
                startTags = startTags.replace(startRE,"\{\{");
                endTags = endTags.replace(endRE,"\}\}");
                return startTags+text+endTags;
              });
            return Handlebars.original_compile(replacedSource);
          };
        };

        Handlebars.setDelimiter('{<','>}');

        // Compile the template
        var theTemplate = Handlebars.compile(theTemplateScript)
        
        var newCurrency = ''
        if ($('[name="currencies"]').size()) {
          newCurrency = $('[name="currencies"]').val()
        } else if ($('#currencies span.selected').size()) {
          newCurrency = $('#currencies span.selected').attr('data-currency')
        }

        if (newCurrency) {
          var pPrice = Shopify.formatMoney(Currency.convert(product.price, defaultCurrency , newCurrency), (Currency.moneyFormats[newCurrency]).money_with_currency_format)
          var pCmpPrice = Shopify.formatMoney(Currency.convert(product.compareAtPrice, defaultCurrency , newCurrency), (Currency.moneyFormats[newCurrency]).money_with_currency_format)
        } else {
          var pPrice = Shopify.formatMoney(product.price)
          var pCmpPrice = Shopify.formatMoney(product.compareAtPrice)
        }

        // This is the default context, which is passed to the template
        var context = {
          product: product,
          price: pPrice,
          compareAtPrice: pCmpPrice,
          description: Handlebars.Utils.escapeExpression(product.description.split(" ").splice(0, 20).join(" "))
        }
        
        // Pass our data to the template
        var theCompiledHtml = theTemplate(context)
        
        // Add the compiled html to the page
        $('.modal-body').html(theCompiledHtml)

        if (product.variants.length > 1) {
          var index = 0
          for (var option of product.options) {
            var optionSelector = $("<label />", { class: "product-title-3 disp-block", html: option.name })
            optionSelector.attr({htmlFor: `SingleOptionSelector-${index}`})
            var selectorWrapper = $("<div />", { class: "selector-wrapper js" } )
            var fSelect = $("<select />", { id: `SingleOptionSelector-${index}`, data: { single: { option: { selector: "" } }, index: `option${index}`} } )          
            selectorWrapper.append(fSelect)
            modal.find('.variants').append(optionSelector, selectorWrapper)
            selectorWrapper.append(fSelect)

            for(var tValue of option.values) {
              var tOption = $("<option />", { value: tValue} ) 
              if ( $(`#SingleOptionSelector-${index}`).val() == tValue || $(`#SingleOptionSelector-${index}`).val() == null) {
                tOption.prop('selected', true)
              }
              fSelect.append(tOption)
            }

            var variantsOptions = $("<div />", {class: "variant-options"})
            selectorWrapper.append(variantsOptions)
            
            var check = false
            for(var val of option.values) {
              var inputVal = $("<input />", { id:`product-${index}-${val}`, name: `SingleOptionSelector-${index}`,  value: val, type: "radio"} )
              
              var check = !!($(`#SingleOptionSelector-${index}`).val() == val || $(`#SingleOptionSelector-${index}`).val() == null)

              var productVariantDiv = $("<div />", { class: "product-variant-option", data: { type: option.name } } )
              
              productVariantDiv.data( {
                type: option.name,
                var: val
              })

              var variantLabel = $("<label />", { html: val })
              productVariantDiv.append(variantLabel)
              inputVal.data("type", option.name )
              if(check) {
                inputVal.prop("checked", true).attr("checked", true)
              } 
              variantsOptions.append(inputVal, productVariantDiv)
            }
            index += 1
          }
          var iSelect = $("<select />", { name: "id", class: "no-js js-id-select", data: { product: { set: "" } } } )
          for(var variant of product.variants) {
            iSelect.append(
              $("<option />", { value: variant.id, html: variant.title } )
            )
          }
          modal.find('.variants').append(iSelect)
          Shopify.AjaxifyCart.init()
        } else {  
          var idSel = $("<select />", { name: "id", class: "no-js js-single-id-select", data: { product: { set: product.variants[0].id } } } )
          idSel.append(
            $("<option />", { value: product.variants[0].id, html: product.variants[0].title } )
          )
          modal.find('form').append(idSel)
          Shopify.AjaxifyCart.init()
        }
      }) 
    })
  })
})